export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7540.bb3a57a7.jpg";